<template>
<div class="TableNews">
  <v-data-table
    :headers="headers"
    :items="news"
    class="px-5 services-table"
    :loading="loading.load"
    loading-text="Загрузка... Пожалуйста подождите"
    :mobile-breakpoint="300"
    :page="1"
    :items-per-page="10"
    :height="tableHeight"
    fixed-header
    hide-default-footer
  >
    <template v-slot:item.comment="{ item }">
      <v-text-field
        label="Комментарий"  class="font-sm"
        dense
        hide-details
        outlined
      />
    </template>
    <template v-slot:item.is_active="{ item }">
      <div class="badge font-xs " :class="newsStatusBadgeClass(item)">
        {{ item.is_active ? 'Опубликовано' : 'Черновик' }}
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        class="background_transparent"
        small
        color="white"
        outlined
        @click="actionButton(item)"
      >
        {{newsStatusActionButton(item)}}
      </v-btn>
    </template>

    <template v-slot:item.created_at="{ item }">
      <div class="d-flex justify-space-between align-center">
        {{ $moment(item.created_at).format('DD.MM.YYYY') }}
      </div>
    </template>
    <template v-slot:item.toolbar="{ item }">
      <v-btn
        small
        class="background_transparent no-border"
      >
        <img src="@/assets/images/profile/arrowGo.svg" />

      </v-btn>
      <v-btn
        small
        class="background_transparent no-border"
        @click="goToEdit(item)"
      >
        <v-icon >mdi-pencil-outline</v-icon>

      </v-btn>
      <v-btn
        small
        class="background_transparent no-border"
        @click="$emit('deleteNews',item)"
      >
        <v-icon class="cursor-pointer">mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      Новостей не найдено.
    </template>

    <template v-slot:footer="{ props }">
      <v-data-footer
        :pagination="props.pagination"
        :options="props.options"
        items-per-page-text="Новостей на странице:"
        :items-per-page-options="[10, 20, 50, 100, 500, 1000]"
        :page-text="`Всего Новостей: ${props.pagination.itemsLength}. Страница ${props.options.page} из ${props.pagination.pageCount}`"
        show-current-page
        show-first-last-page
      />
    </template>
  </v-data-table>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * Компонент: TableNews
 * Описание:
 */
export default {
  name: 'TableNews',

  components: {},

  emits: ['publishedNews', 'draftedNews', 'editItem'],
  data: () => ({
    tableHeight: 400,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: '',
        value: 'check',
        sortable: false,
        width: '60px',
      },
      {
        text: 'Название модального окна',
        align: 'start',
        value: 'title',
        width: '280px',
        sortable: true,
      },
      {
        text: 'Статус окна',
        value: 'is_active',
        width: '180px',
        sortable: true,
      },
      {
        text: 'Дата создания',
        value: 'created_at',
        width: '150px',
        sortable: false,

      },
      {
        text: '',
        align: 'center',
        value: 'actions',
        width: '150px',
      },
      {
        text: '',
        align: 'start',
        value: 'comment',
        width: '250px',
      },
      {
        text: '',
        align: 'start',
        value: 'toolbar',
        width: '220px',
      },
    ],
    paginationData: null,
  }),
  computed: {
    ...mapGetters({
      loading: 'services/services/GET_LOADING_SERVICES',
      news: 'news/modals/allNews',
    }),

  },
  watch: {
  },
  methods: {
    newsStatusBadgeClass(item) {
      switch (item.is_active) {
        case false:
          return 'badge-draft';
        case true:
          return 'badge-published';
        default:
          return 'd-none';
      }
    },
    newsStatusActionButton(news) {
      switch (news.is_active) {
        case false:
          return 'Опубликовать';
        case true:
          return 'Скрыть';
        default:
          return 'd-none';
      }
    },
    goToEdit(news) {
      this.$emit('editItem', news);
    },
    onPublishedService(news) {
      this.$emit('publishedNews', news, true);
    },
    onDraftedService(news) {
      this.$emit('draftedNews', news, false);
    },
    actionButton(news) {
      switch (news.is_active) {
        case false:
          this.onPublishedService(news);
          break;
        case true:
          this.onDraftedService(news);
          break;
        default: {
          return false;
        }
      }
    }
  },
  created() {
  },
  mounted() {
    const height = document.documentElement.clientHeight - 270;
    this.tableHeight = Math.max(height, this.tableHeight);
  },
};
</script>

<style scoped lang="scss">
.TableNews {
  & thead{
    background: red;
  }
  & .v-btn{
    background: var(--color-blue-500);
    border-radius: 6px;
    font-size: 16px;
    padding: 10px 8px;
    ::v-deep span{
      line-height: 24px;
    }
    &.background_transparent{
      background: transparent;
      color: var(--color-blue-500)!important;
      &.no-border{
        border: none;
        box-shadow: none;
        color: var(--color-grey-500)!important;
        &:hover{
          box-shadow: none!important;
        }
      }
    }
  }
}
</style>
